let promptEnable = true

export function isPromptEnable(): boolean {
  return promptEnable
}

export function setPromptEnable(enabled: boolean): void {
  promptEnable = enabled
}
